import isProduction from 'app/common/lib/isProduction'

// Статическое включение/выключение некоторого функционала

export const dishesFeatures = {
  // колонка "Уровень готовности"
  processingLevel: !isProduction(),
  // колонка с выбором единицы измерения
  unit: !isProduction(),
  // кнопки перехода в техкарту и КБЖУ в колонке типа продукции + блокировка route техкарты
  kbzhuAndTechCard: !isProduction(),
  // скачивание техкарты (кнопка над таблицей, появляется при наличии выбранных блюд)
  techCardDownload: !isProduction(),
  // отображение штрихкода в колонке "Наименование"
  barcode: !isProduction(),
  // массовое изменение типов продукции, групповая кнопка в toolbar (участвуют выделенные чекбоксом блюда)
  selectedDishesTypesChange: !isProduction(),
}
